import type { SearchSortField } from 'lib-search-types';
import { SortBy } from 'lib-shared-legacy-types';

type SearchResultsSortOption = {
  value: SortBy<SearchSortField<'conversations'>> | '';
  label: string;
};

export const sortOptions: SearchResultsSortOption[] = [
  {
    value: '',
    label: 'Relevance',
  },
  {
    value: 'updated_at:desc',
    label: 'Activity: Newest first',
  },
  {
    value: 'updated_at:asc',
    label: 'Activity: Oldest first',
  },
  {
    value: 'created_at:desc',
    label: 'Created: Newest first',
  },
  {
    value: 'created_at:asc',
    label: 'Created: Oldest first',
  },
  {
    value: 'last_message_created_at:desc',
    label: 'Last message: Newest first',
  },
  {
    value: 'last_message_created_at:asc',
    label: 'Last message: Oldest first',
  },
];
